// Builds argv + child env for a session, wrapping argv/env ContractErrors
// into a SessionRunResult so session-runner.ts can return early without its
// own try/catch. Split out to keep session-runner.ts under the 200-line
// budget.
import type { BindingWriteResult } from "./autopilot-binding-file-writer.js";
import {
  assertNoKnownSecretValuesInChildEnv,
  buildChildEnvAllowlist,
  ContractError as EnvContractError,
} from "./child-env-allowlist-builder.js";
import {
  ContractError as ArgvContractError,
  buildClaudeHeadlessArgv,
} from "./claude-headless-argv-builder.js";
import type { SessionRunResult, SessionSpec } from "./session-runner.js";

export type ArgvEnvBuildResult =
  | { ok: true; argv: string[]; env: Record<string, string> }
  | { ok: false; error: SessionRunResult };

export function buildArgvAndEnv(
  spec: SessionSpec,
  t0: number,
  binding: BindingWriteResult,
): ArgvEnvBuildResult {
  try {
    const argv = buildClaudeHeadlessArgv(
      { sessionId: spec.sessionId, allowedTools: spec.allowedTools, workerModel: spec.workerModel },
      {},
    );
    const env = buildChildEnvAllowlist(process.env, {
      missionId: spec.missionId,
      ticketId: spec.ticketId,
      runId: spec.runId,
      repoRoot: spec.repoRoot,
    });
    // Phase 04b (I3): known-values lúc spawn (supervisor-attempt-cycle.ts cấp từ registry);
    // M1: so với CÙNG env cha builder vừa chép.
    assertNoKnownSecretValuesInChildEnv(env, spec.secretValues ?? [], process.env);
    return { ok: true, argv, env };
  } catch (err) {
    if (err instanceof ArgvContractError || err instanceof EnvContractError) {
      return {
        ok: false,
        error: {
          outcome: "contract_error",
          reason: err.message,
          spawnAt: t0,
          bindingPath: binding.bindingPath,
          bindingHash: binding.checksum,
        },
      };
    }
    throw err;
  }
}
